import { layoutRows, PrintSource, segmentLines } from './layout';
import { Base64Png, renderSegment } from './render';

export * from './layout';
export type { Base64Png } from './render';
export { renderReceiptDocument } from './receipt';

export interface AdyenPrintJob {
  /** The print payload as handed to PrinterManager: plain text or formatted rows. */
  data: PrintSource;
  /** Optional logo PNG data URL, drawn above the first segment. */
  logoDataUrl?: string;
}

/**
 * Converts a row-based print payload (bongs, reports, test prints) into one or more base64
 * PNG images sized for the terminal printer. Images must be sent to the terminal in order;
 * each one is a contiguous slice of the print so the paper reads as a single document.
 *
 * Receipts have a structured model and are rendered with renderReceiptDocument() instead.
 */
export const renderAdyenPrintJob = async ({
  data,
  logoDataUrl,
}: AdyenPrintJob): Promise<Base64Png[]> => {
  const segments = segmentLines(layoutRows(data));

  if (!segments.length) {
    return logoDataUrl ? [await renderSegment({ lines: [], logoDataUrl })] : [];
  }

  const images: Base64Png[] = [];

  for (let i = 0; i < segments.length; i++) {
    images.push(
      await renderSegment({
        lines: segments[i],
        logoDataUrl: i === 0 ? logoDataUrl : undefined,
      }),
    );
  }

  return images;
};
